import { render, staticRenderFns } from "./FinalizacaoProdutos.vue?vue&type=template&id=de0b7ad6"
import script from "./FinalizacaoProdutos.vue?vue&type=script&lang=js"
export * from "./FinalizacaoProdutos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports